import React from 'react'
import PropTypes from 'prop-types'
import { Fieldset } from 'primereact/fieldset'
import styleMemory from '../../../../../css/generals/Memory.module.css'
import { useTranslation } from 'react-i18next'

export default function Memory ({ memoirs }) {
  const { t } = useTranslation('hardware')

  return (
    <div style={{ marginTop: '1rem' }}>
        <Fieldset legend={t('title3')} toggleable className={ styleMemory.legendHeader }>
            <p><span className={ styleMemory.bold }>{t('label8')}</span><span>{memoirs?.slotsMemory ? memoirs?.slotsMemory.total : t('notAvailable')}</span></p>
            <p><span className={ styleMemory.bold }>{t('label9')}</span><span>{memoirs?.slotsMemory ? memoirs?.slotsMemory.total - memoirs?.slotsMemory.available : t('notAvailable')}</span></p>
        </Fieldset>
        {memoirs?.memory.length > 0 && memoirs?.memory.map((item, index) => {
          return (
                <Fieldset key={index + 1} legend={`${t('title4')} ${index + 1}`} toggleable className={ styleMemory.legendHeader }>
                    <p><span className={ styleMemory.bold }>{t('label10')}</span><span>{item?.Capacity ? Math.floor((parseInt(item?.Capacity) / 1073741824)) + 'GB' : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label11')}</span><span>{item?.Description ? item?.Description : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label1')}</span><span>{item?.Manufacturer ? item?.Manufacturer : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label2')}</span><span>{item?.Name ? item?.Name : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label12')}</span><span>{item?.Model ? item?.Model : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label3')}</span><span>{item?.SerialNumber ? item?.SerialNumber : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label13')}</span><span>{item?.Speed ? item?.Speed + ' MHz' : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label14')}</span><span>{item?.PartNumber ? item?.PartNumber : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label15')}</span><span>{item?.SMBIOSMemoryType ? parseInt(item?.SMBIOSMemoryType) === 26 ? 'DDR4' : parseInt(item?.SMBIOSMemoryType) === 34 ? 'DDR5' : parseInt(item?.SMBIOSMemoryType) === 24 ? 'DDR3' : parseInt(item?.SMBIOSMemoryType) === 21 ? 'DDR2' : t('label16') : t('notAvailable')}</span></p>
                </Fieldset>
          )
        })}
    </div>
  )
}

Memory.propTypes = {
  memoirs: PropTypes.object
}
